import controller from './query-classes.controller';
import template from './query-classes.html';
import './query-classes.scss';

export default {
	controller,
	template,
	bindings: {
		classes:     '<ngModel',
		disabled:    '<?ngDisabled',
		options:     '<?',
		targetModel: '=?',
	},
	require:  {
		ngModelCtrl: 'ngModel',
		editor:      '^^?queryEditor',
	},
};
